/**
 * 직원록 목록 데이터
 */
const RedBookData = [
    {
        "book_id" : 1,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "職員錄  隆熙2年 6月",
        "book_title_ko" : "대한제국 직원록 1908년도",
        "numeration" : "1908",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1908,
        "publish_month" : null,
        "publish_day" : null,
        "publish_date" : "隆熙2年",
        "publisher" : "大韓帝國 內閣記錄課",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 2,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "職員錄 隆熙3年 6月",
        "book_title_ko" : "대한제국 직원록 1909년도",
        "numeration" : "1909",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1909,
        "publish_month" : null,
        "publish_day" : null,
        "publish_date" : "隆熙3年",
        "publisher" : "大韓帝國 內閣記錄課",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국립중앙도서관 소장본",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 3,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  明治43年 12月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1910년도",
        "numeration" : "1910",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1911,
        "publish_month" : 2,
        "publish_day" : 14,
        "publish_date" : "明治44年 2月 14日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "明治44年 2月 10日 印刷, 明治44年 2月 14日 發行, 朝鮮總督府, 印刷所 朝鮮總督府印刷局; 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 4,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  明治44年 11月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1911년도",
        "numeration" : "1911",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1912,
        "publish_month" : 1,
        "publish_day" : 31,
        "publish_date" : "明治45年 1月 31日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "明治45年 1月 27日 印刷, 明治45年 1月 31日 發行, 朝鮮總督府, 印刷所 朝鮮總督府印刷局; 국사편찬위원회MF",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 5,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正元年 11月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1912년도",
        "numeration" : "1912",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1913,
        "publish_month" : 1,
        "publish_day" : 1,
        "publish_date" : "大正2年 1月 1日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正元年 12月 28日 印刷, 大正2年 1月 1日 發行, 朝鮮總督府, 朝鮮總督官房總務局印刷所, 發賣所 京城本町二丁目 日韓書房; 국사편찬위원회MF",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 6,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "職員錄(甲)  大正2年 7月 1日",
        "book_title_ko" : "일본제국직원록 조선총독부편 1913년도",
        "numeration" : "1913",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1913,
        "publish_month" : 9,
        "publish_day" : 27,
        "publish_date" : "大正2年 9月 27日",
        "publisher" : "日本 內閣印刷局",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국사편찬위원회MF",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 7,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正3年 4月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1914년도",
        "numeration" : "1914",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1914,
        "publish_month" : 6,
        "publish_day" : 7,
        "publish_date" : "大正3年 6月 7日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正3年 6月 4日 印刷, 大正3年 6月 7日 發行, 朝鮮總督府編纂, 朝鮮總督官房總務局印刷所印刷, 發賣所 京城本町二丁目 日韓書房; 국사편찬위원회MF",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 8,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "職員錄(甲)  大正4年 5月 1日",
        "book_title_ko" : "일본제국직원록 조선총독부편 1915년도",
        "numeration" : "1915",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1915,
        "publish_month" : 7,
        "publish_day" : 28,
        "publish_date" : "大正4年 7月 28日",
        "publisher" : "日本 內閣印刷局",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국사편찬위원회MF",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 9,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正5年 1月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1916년도",
        "numeration" : "1916",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1916,
        "publish_month" : 3,
        "publish_day" : 31,
        "publish_date" : "大正5年 3月 31日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正5年 3月 27日 印刷, 大正5年 3月 31日 發行, 朝鮮總督府編纂, 日韓印刷株式會社 朝鮮京城, 大賣捌所 京城本町一丁目 大阪屋號書店; 국사편찬위원회MF",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 10,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正6年 1月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1917년도",
        "numeration" : "1917",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1917,
        "publish_month" : 3,
        "publish_day" : 31,
        "publish_date" : "大正6年 3月 31日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正6年 3月 27日 印刷, 大正6年 3月 31日 發行, 朝鮮總督府編纂, 日韓印刷株式會社印刷 朝鮮京城, 大賣捌所 京城本町一丁目 大阪屋號書店; 국사편찬위원회MF",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 11,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正7年 1月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1918년도",
        "numeration" : "1918",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1918,
        "publish_month" : 3,
        "publish_day" : 31,
        "publish_date" : "大正7年 3月 31日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正7年 3月 27日 印刷, 大正7年 3月 31日 發行, 朝鮮總督府編纂, 日韓印刷所印刷 朝鮮京城; 국사편찬위원회MF",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 12,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正8年 1月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1919년도",
        "numeration" : "1919",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1919,
        "publish_month" : 3,
        "publish_day" : 31,
        "publish_date" : "大正8年 3月 31日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正8年 3月 27日 印刷, 大正8年 3月 31日 發行, 朝鮮總督府編纂, 日韓印刷所印刷 朝鮮京城; 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 13,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正9年 1月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1920년도",
        "numeration" : "1920",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1920,
        "publish_month" : 3,
        "publish_day" : 31,
        "publish_date" : "大正9年 3月 31日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正9年 3月 27日 印刷, 大正9年 3月 31日 發行, 朝鮮總督府編纂, 日韓印刷所印株式會社 朝鮮京城; 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 14,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正10年 1月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1921년도",
        "numeration" : "1921",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1921,
        "publish_month" : 3,
        "publish_day" : 31,
        "publish_date" : "大正10年 3月 31日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正10年 3月 26日 印刷, 大正10年 3月 31日 發行, 朝鮮總督府編纂, 日韓印刷所印株式會社 朝鮮京城; 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 15,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正11年 1月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1922년도",
        "numeration" : "1922",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1922,
        "publish_month" : null,
        "publish_day" : null,
        "publish_date" : "大正11年",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국사편찬위원회MF",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 16,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正12年 4月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1923년도",
        "numeration" : "1923",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1923,
        "publish_month" : 7,
        "publish_day" : 20,
        "publish_date" : "大正12年 7月 20日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正12年 7月 16日 印刷, 大正12年 7月 20日 發行, 朝鮮總督府編纂, 帝國地方行政學會(東京市京橋區加賀町9,10,11番地), 帝國地方行政學會 朝鮮本部(京城府長谷川町93番地); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 17,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正13年 4月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1924년도",
        "numeration" : "1924",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1924,
        "publish_month" : null,
        "publish_day" : null,
        "publish_date" : "大正13年",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 18,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正14年 4月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1925년도",
        "numeration" : "1925",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1925,
        "publish_month" : 7,
        "publish_day" : 20,
        "publish_date" : "大正14年 7月 20日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正14년 7月 17日 印刷, 大正14年 7月 20日 發行, 朝鮮總督府編纂, 株式會社 大海堂(京城府太平通2丁目1番地); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 19,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  大正15年 4月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1926년도",
        "numeration" : "1926",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1926,
        "publish_month" : 7,
        "publish_day" : 30,
        "publish_date" : "大正15年 7月 30日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "大正15년 7月 1日 印刷, 大正15年 7月 30日 發行, 朝鮮總督府編纂, 合名會社 近澤印刷部(京城府長谷川町76番地); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 20,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和2年 4月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1927년도",
        "numeration" : "1927",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1927,
        "publish_month" : 6,
        "publish_day" : 2,
        "publish_date" : "昭和2年 6月 2日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "昭和2年 5月 28日 印刷, 昭和2年 6月 2日 發行, 朝鮮總督府編纂, 印刷所 朝鮮印刷 株式會社(京城府蓬萊町3丁目62·3番地, 振替口座 京城40番, 電話本局(230番, 4131番, 長4132番)); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 21,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和3年 4月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1928년도",
        "numeration" : "1928",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1928,
        "publish_month" : 6,
        "publish_day" : 13,
        "publish_date" : "昭和3年 6月 13日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "昭和3年 6月 10日 印刷, 昭和3年 6月 30日 發行, 朝鮮總督府編纂, 印刷所 朝鮮印刷 株式會社(京城府蓬萊町3丁目62·3番地, 振替口座 京城40番, 電話本局(230番, 4131番, 長4132番)); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 22,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和4年 4月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1929년도",
        "numeration" : "1929",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1929,
        "publish_month" : 6,
        "publish_day" : 15,
        "publish_date" : "昭和4年 6月 15日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "昭和4年 6月 13日 印刷, 昭和4年 6月 15日 發行, 朝鮮總督府編纂, 印刷所 行政學會印刷所(京城府南米倉町159番地, 振替口座 京城9974, 電話本局 2818番); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 23,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和5年 7月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1930년도",
        "numeration" : "1930",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1930,
        "publish_month" : 7,
        "publish_day" : 15,
        "publish_date" : "昭和5年 7月 15日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 24,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和6年 7月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1931년도",
        "numeration" : "1931",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1931,
        "publish_month" : 8,
        "publish_day" : 31,
        "publish_date" : "昭和6年 8月 31日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "昭和6年 8月 28日 印刷, 昭和6年 8月 31日 發行, 朝鮮總督府編纂, 印刷所 朝鮮印刷 株式會社(京城府蓬萊町3丁目62·3番地, 振替口座 京城40番, 電話本局(230番, 4131番, 長4132番)); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 25,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和7年 4月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1932년도",
        "numeration" : "1932",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1932,
        "publish_month" : 6,
        "publish_day" : 2,
        "publish_date" : "昭和7年 6月 2日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 26,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和8年 4月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1933년도",
        "numeration" : "1933",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1933,
        "publish_month" : 6,
        "publish_day" : 20,
        "publish_date" : "昭和8年 6月 20日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 27,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和9年 7月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1934년도",
        "numeration" : "1934",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1934,
        "publish_month" : 8,
        "publish_day" : 28,
        "publish_date" : "昭和9年 8月 28日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 28,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和10年 7月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1935년도",
        "numeration" : "1935",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1935,
        "publish_month" : 10,
        "publish_day" : 10,
        "publish_date" : "昭和10年 10月 10日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 29,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和11年 7月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1936년도",
        "numeration" : "1936",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1936,
        "publish_month" : 9,
        "publish_day" : 15,
        "publish_date" : "昭和11年 9月 15日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "昭和11年 9月 10日 印刷, 昭和11年 9月 15日 發行, 朝鮮總督府編纂, 發賣所 朝鮮印刷 株式會社(京城府蓬萊町3丁目62·3番地, 振替口座 京城40番, 電話本局②(230番, 5531番, ■5532番)); 국회도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 30,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和12年 8月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1937년도",
        "numeration" : "1937",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1937,
        "publish_month" : 10,
        "publish_day" : 20,
        "publish_date" : "昭和12年 10月 20日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "昭和12年 10月 15日 印刷, 昭和12年 10月 20日 發行, 朝鮮總督府編纂, 發賣所 帝國地方行政學會朝鮮本部(京城府太平通2丁目, 振替口座 京城815番, 電話本局②(0158番, 0159番, 2772番)); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 31,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和13年 8月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1938년도",
        "numeration" : "1938",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1938,
        "publish_month" : 10,
        "publish_day" : 25,
        "publish_date" : "昭和13年 10月 25日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "昭和13年 10月 21日 印刷, 昭和13年 10月 25日 發行, 朝鮮總督府編纂, 印刷所 行政學會印刷所(京城府南米倉町159, 電話本局②(2818番, 3533番)), 發賣所 帝國地方行政學會朝鮮本部(京城府太平通2丁目, 振替口座 京城815番, 電話本局②(0158番, 0159番, 2772番)); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 32,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和14年 7月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1939년도",
        "numeration" : "1939",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1939,
        "publish_month" : 10,
        "publish_day" : 20,
        "publish_date" : "昭和14年 10月 20日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "昭和14年 10月 15日 印刷, 昭和14年 10月 20日 發行, 朝鮮總督府編纂, 印刷所 行政學會印刷所(京城府南米倉町159番地, 電話本局②(2818番, 3533番)), 帝國地方行政學會朝鮮本部(京城府太平通2丁目43番地, 電話本局②(0158番, 0159番, 2772番, 振替口座 京城815番)); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 33,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和15年 7月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1940년도",
        "numeration" : "1940",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1940,
        "publish_month" : 11,
        "publish_day" : 10,
        "publish_date" : "昭和15年 11月 10日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 34,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署 職員錄  昭和16年 7月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1941년도",
        "numeration" : "1941",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1941,
        "publish_month" : 12,
        "publish_day" : 25,
        "publish_date" : "昭和16年 12月 25日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "昭和16年 12月 20日 印刷, 昭和16年 12月 25日 發行, 朝鮮總督府編纂, 印刷所 株式會社 行政學會印刷所(京城府南米倉町159番地), 發賣所 朝鮮行政學會(京城府太平通2丁目43番地, 電話本局② 0158·0159·2772番, 振替口座 京城815番); 국립중앙도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 35,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "朝鮮總督府及所屬官署職員錄 昭和17年 7月 1日",
        "book_title_ko" : "조선총독부및소속관서직원록 1942년도",
        "numeration" : "1942",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1942,
        "publish_month" : 3,
        "publish_day" : 25,
        "publish_date" : "昭和18年 3月 25日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "국립중앙도서관 소장본",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 36,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "職員錄  昭和18年 7月 1日",
        "book_title_ko" : "일본제국직원록 1943년도",
        "numeration" : "1943",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1943,
        "publish_month" : 9,
        "publish_day" : 30,
        "publish_date" : "昭和18年 9月 30日",
        "publisher" : "朝鮮總督府",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "內閣印刷局 編; 일본국회도서관 소장 이미지",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 37,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "職員錄  檀紀4285年",
        "book_title_ko" : "대한민국직원록 1952년도",
        "numeration" : "1952",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1953,
        "publish_month" : 9,
        "publish_day" : 15,
        "publish_date" : "檀紀4285年 9月 15日",
        "publisher" : "大韓出版文化社",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "檀紀4285年 9月 15日 印刷 發行, 發行人 金東郁, 印刷所 高麗印刷所, 發行處 大韓出版文化社(서울特別市中區會賢洞1街14, 登錄 檀紀4283年 11月 1日, 登錄番號 第40號)",
        "search_tag" : null,
        "usernote" : null
    },
    {
        "book_id" : 38,
        "book_type" : null,
        "book_category" : "redbook",
        "book_title" : "政府職員錄 檀紀4286年 12月 1日",
        "book_title_ko" : "대한민국직원록 1953년도",
        "numeration" : "1953",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1954,
        "publish_month" : null,
        "publish_day" : null,
        "publish_date" : "檀紀4287年",
        "publisher" : "總務處",
        "publisher_ko" : null,
        "library" : null,
        "url" : null,
        "note" : "규장각한국학연구원",
        "search_tag" : null,
        "usernote" : null
    }
]

export default RedBookData;